import { toast } from "react-toastify";

const { ethers } = require("ethers");

const detectAndSwitchChain = async (newChain) => {
  if (!window.ethereum) {
    console.error("window.ethereum is not available");
    return;
  }
  const { ethereum } = window;
  if (!ethereum.isMetaMask) {
    console.error("Please install MetaMask");
    return;
  }
  try {
    const provider = new ethers.providers.Web3Provider(ethereum);
    const { chainId } = await provider.getNetwork();
    if (+chainId !== +newChain) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: `0x${+newChain.toString(16)}` }],
        });
        return true;
      } catch (switchError) {
        if (switchError.code === 4902) {
          toast.error("Please add the network to your wallet");
        } else {
          throw switchError;
        }
        return false;
      }
    }
    return true;
  } catch (error) {
    console.error(error);
  }
};

export default detectAndSwitchChain;
